import View from "../framework/view";

export type Euros = number;

/**
 * A HashUrl is the part of the hash excluding the leading # (and starting with / according to the conventions in this app)
 */
export type HashUrl = string;

/**
 * Pug templates
 */
export type Template = (locals: any) => string;

/**
 * Represents a function that can be displayed in the main pane of the application.
 * A function has a representation as a hash-URL (so functions can be loaded directly via URL)
 */
export abstract class AppFunction {

    abstract view(): View;

    abstract url(): HashUrl;

    isRoot(): boolean {
        return false;
    }

    /**
     * @return true if the function has "zero" navigation (eg, login page)
     */
    isZero(): boolean {
        return false;
    }

    /**
     * Override to return a custom page template
     */
    pageTemplate() : Template | undefined {
        return undefined;
    }

    /**
     * Most functions aren't available offline. Subclasses can override this to indicate that they
     * are offline enabled.
     */
    offlineEnabled() : boolean {
        return false;
    }

    /**
     * Functions can be "cacheable", which means that new instances are not created each time the
     * URL is visited. This is good for maintaining model state.
     */
    isCacheable() {
        return false;
    }

    refresh() {
        // NOP
    }

}

export type JsonDate = string; // yyyy-mm-dd

export type AusDollar = number;

export type AusCents = number;

export const ROLE_ADMIN = "admin";
export const ROLE_EDITOR = "editor";
export const ROLE_USER = "member";
export const ROLE_NONE = "none";

export type Role = "admin" | "editor" | "member" | "none";

export const roles = [
    ROLE_ADMIN,
    ROLE_EDITOR,
    ROLE_USER,
    ROLE_NONE
];
